import React, { useState, useEffect, useRef } from "react";
import "./Game4.css";
import { PauseOutlined, RedoOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";

export default function Game4() {
  const [items, setItems] = useState([]);
  const [basketPosition, setBasketPosition] = useState(50); // basket position in percentage
  const [score, setScore] = useState(0);
  const [missed, setMissed] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const [paused, setPaused] = useState(false);
  const [fallingSpeed, setFallingSpeed] = useState(5);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showNewGameButton, setShowNewGameButton] = useState(false);
  const gameAreaRef = useRef(null);

  useEffect(() => {
    if (!gameOver && !paused) {
      const interval = setInterval(() => {
        setItems((prevItems) => [...prevItems, createNewItem()]);
      }, 500); // Faster spawn interval

      return () => clearInterval(interval);
    }
  }, [gameOver, paused]);

  useEffect(() => {
    const handleMovement = (e) => {
      if (e.key === "ArrowLeft" && basketPosition > 0) {
        setBasketPosition((prevPosition) => prevPosition - 5);
      } else if (e.key === "ArrowRight" && basketPosition < 90) {
        setBasketPosition((prevPosition) => prevPosition + 5);
      }
    };

    window.addEventListener("keydown", handleMovement);

    return () => window.removeEventListener("keydown", handleMovement);
  }, [basketPosition]);

  useEffect(() => {
    if (!paused) {
      const interval = setInterval(() => {
        setItems((prevItems) =>
          prevItems
            .map((item) => ({
              ...item,
              top: item.top + fallingSpeed,
            }))
            .filter((item) => {
              if (
                item.top >= 90 &&
                item.left >= basketPosition &&
                item.left <= basketPosition + 10
              ) {
                setScore((prevScore) => prevScore + 1);
                return false;
              } else if (item.top >= 100) {
                setMissed((prevMissed) => {
                  const newMissed = prevMissed + 1;
                  if (newMissed >= 200) {
                    setGameOver(true);
                    setIsModalOpen(true);
                  }
                  return newMissed;
                });
                return false;
              }
              return true;
            })
        );
      }, 100);

      return () => clearInterval(interval);
    }
  }, [items, basketPosition, fallingSpeed, paused]);

  useEffect(() => {
    if (!gameOver && score > 0 && score % 10 === 0) {
      setFallingSpeed((prevSpeed) => prevSpeed + 1); // Increase falling speed
    }
  }, [score, gameOver]);

  const createNewItem = () => {
    return {
      left: Math.floor(Math.random() * 90),
      top: 0,
    };
  };

  const handleRestart = () => {
    setItems([]);
    setScore(0);
    setMissed(0);
    setGameOver(false);
    setPaused(false);
    setFallingSpeed(5);
    setIsModalOpen(false);
    setShowNewGameButton(false);
  };

  const handlePauseResume = () => {
    setPaused((prevPaused) => !prevPaused);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setShowNewGameButton(true);
  };

  const handleNewGame = () => {
    handleRestart();
  };

  return (
    <div className="Game4-Body" ref={gameAreaRef}>
      <div className="Game4-Div">
        <p className="Game4-Text1">Score: {score}</p>
        <div className="Game4-Div2">
          {!gameOver && (
            <button className="Game4-button" onClick={handlePauseResume}>
              {paused ? <RedoOutlined /> : <PauseOutlined />}
            </button>
          )}
        </div>
        <p className="Game4-Text1"> Missed: {missed}</p>
      </div>
      <div className="Game4-Box">
        {items.map((item, index) => (
          <div
            key={index}
            className="falling-item"
            style={{ left: `${item.left}%`, top: `${item.top}%` }}
          ></div>
        ))}
        <div className="basket" style={{ left: `${basketPosition}%` }}></div>
      </div>
      {gameOver && (
        <Modal
          title="Game Over"
          visible={isModalOpen}
          onOk={handleCloseModal}
          onCancel={handleCloseModal}
          footer={[
            <Button key="close" onClick={handleCloseModal}>
              Close
            </Button>,
            <Button key="restart" type="primary" onClick={handleRestart}>
              Restart
            </Button>,
          ]}
        >
          <p>Final Score: {score}</p>
          <p>You missed {missed} items</p>
        </Modal>
      )}
      {paused && !gameOver && (
        <div className="Game4-NewGameButton">
          <Button type="primary" onClick={handleNewGame}>
            New Game
          </Button>
        </div>
      )}
      {showNewGameButton && (
        <div className="Game4-NewGameButton">
          <Button type="primary" onClick={handleNewGame}>
            New Game
          </Button>
        </div>
      )}
    </div>
  );
}
